import { IImage } from "@montana/models/generated/cms.interface";
import React from "react"

interface ICarouselProductImageProps {
    image: IImage;
}

export const CarouselProductImage: React.FC<ICarouselProductImageProps> = React.memo(({
    image,
}: ICarouselProductImageProps): JSX.Element => {
    return (
        <div className="carousel-product__border">
            <div className="carousel-product__image">
                <img src={image.url} />
            </div>
        </div>
    )
})
